import React from 'react';
import { Zap, ArrowDown } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-white" data-id="element-113">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-marron mb-6" data-id="element-116">
            El Problema No Son las Hierbas.
            <br data-id="element-117" />
            Es Que las Estás Usando Mal.
          </h2>
          <p className="text-lg text-marron-light leading-relaxed" data-id="element-118">
            Acá está el secreto que los herboristas tradicionales conocen hace
            siglos y que la ciencia moderna está recién confirmando:
          </p>
          <p className="text-xl font-bold text-oliva-dark mt-4" data-id="element-119">
            Las plantas medicinales no trabajan solas. Trabajan en equipo.
          </p>
          <p className="text-lg text-marron-light mt-4" data-id="element-120">
            Cuando combinás los ingredientes correctos, en las proporciones
            correctas, y los preparás de la manera correcta — algo
            extraordinario sucede.
          </p>
        </div>

        <div className="bg-marron rounded-2xl p-8 sm:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-121">
          {/* Background decoration */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-oliva opacity-10 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-122"></div>

          <h3 className="text-2xl font-heading font-bold text-mostaza mb-10 text-center uppercase tracking-widest border-b border-white/10 pb-6" data-id="element-123">
            🔬 El Triángulo de Bio-Disponibilidad
          </h3>

          <div className="space-y-8 relative" data-id="element-124">
            {/* Connecting Line */}
            <div className="absolute left-6 top-8 bottom-8 w-0.5 bg-white/20 hidden sm:block" data-id="element-125"></div>

            <div className="relative flex gap-6" data-id="element-126">
              <div className="flex-shrink-0 w-12 h-12 bg-mostaza text-marron rounded-full flex items-center justify-center font-bold text-xl z-10 shadow-lg border-4 border-marron" data-id="element-127">
                1
              </div>
              <div data-id="element-128">
                <h4 className="text-xl font-bold text-mostaza mb-2" data-id="element-129">
                  El Agente Activo
                </h4>
                <p className="text-crema/80" data-id="element-130">
                  El compuesto principal con propiedades terapéuticas. Ej: La
                  curcumina en la cúrcuma, el gingerol en el jengibre, la
                  alicina en el ajo.
                </p>
              </div>
            </div>

            <div className="relative flex gap-6" data-id="element-131">
              <div className="flex-shrink-0 w-12 h-12 bg-mostaza text-marron rounded-full flex items-center justify-center font-bold text-xl z-10 shadow-lg border-4 border-marron" data-id="element-132">
                2
              </div>
              <div data-id="element-133">
                <h4 className="text-xl font-bold text-mostaza mb-2" data-id="element-134">
                  El Catalizador de Absorción
                </h4>
                <p className="text-crema/80" data-id="element-135">
                  El activador que multiplica la absorción. Ej: La piperina en
                  la pimienta negra inhibe la enzima que expulsa la curcumina,
                  aumentando su absorción hasta un{' '}
                  <strong className="text-white" data-id="element-136">2.000%</strong>.
                </p>
              </div>
            </div>

            <div className="relative flex gap-6" data-id="element-137">
              <div className="flex-shrink-0 w-12 h-12 bg-mostaza text-marron rounded-full flex items-center justify-center font-bold text-xl z-10 shadow-lg border-4 border-marron" data-id="element-138">
                3
              </div>
              <div data-id="element-139">
                <h4 className="text-xl font-bold text-mostaza mb-2" data-id="element-140">
                  El Vehículo Lipídico
                </h4>
                <p className="text-crema/80" data-id="element-141">
                  La grasa que transporta los compuestos al torrente sanguíneo.
                  Ej: Aceite de oliva extra virgen o aceite de coco. Sin esto,
                  los polifenoles se excretan sin efecto.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-10 bg-white/10 border border-mostaza/30 rounded-xl p-6 text-center" data-id="element-142">
            <p className="text-lg italic text-crema" data-id="element-143">
              ✨ Lo que era un "tecito" se convierte en una fórmula de precisión
              con efecto real y medible. A esto lo llamamos{' '}
              <strong className="text-mostaza not-italic" data-id="element-144">
                Sinergia Herbal de Precisión.
              </strong>
            </p>
          </div>
        </div>
      </div>
    </section>;
}